import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CardModule } from 'ngx-card/ngx-card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { PaymentFormComponent } from './components/payment-form/payment-form.component';
import { GenericPaymentFormComponent } from './components/generic-payment-form/generic-payment-form.component';
import { RequirementReviewComponent } from './components/requirement-review/requirement-review.component';
import { MainSearchResultsComponent } from './components/main-search-results/main-search-results.component';
import { ComponentLoaderComponent } from './components/component-loader/component-loader.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { DialogYesNoComponent } from './components/dialog-yes-no/dialog-yes-no.component';
import { DialogOkComponent } from './components/dialog-ok/dialog-ok.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { StreetPostalAddressFormComponent } from './components/street-postal-address-form/street-postal-address-form.component';

import { CreditCardSelectorComponent } from 'src/app/core/components/credit-card-selector/credit-card-selector.component';
import { SafePipe } from 'src/app/core/pipes/safe.pipe';
import { EscapeHtmlPipe } from 'src/app/core/pipes/escape-html.pipe';
import { ModuleLoadDirective } from 'src/app/core/directives/module-load.directive'
import { CanDeactivateGuard } from 'src/app/core/guards/can-deactivate-guard.service';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import {
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SubFormComponent } from './components/sub-form/sub-form.component';
import { MainFormComponent } from './components/main-form/main-form.component';
import { SolicitanteComponent } from './components/solicitante/solicitante.component';
import { EmpresaComponent } from './components/empresa/empresa.component';
import { AgenteComponent } from './components/agente/agente.component';
import { NgxExtendedPdfViewerModule, ɵd as PdfFindbarService } from 'ngx-extended-pdf-viewer';
import { CostFormComponent } from 'src/app/core/components/cost-form/cost-form.component';
import { CostItemComponent } from 'src/app/core/components/cost-form/components/cost-item/cost-item.component';
import { CostFormAdminComponent } from './components/cost-form-admin/cost-form-admin.component';
import { CostItemAdminComponent } from './components/cost-form-admin/components/cost-item-admin/cost-item-admin.component';
import { LoaderComponent } from './components/loader/loader.component';
import { PaymentPlanFormComponent } from './components/payment-plan-form/payment-plan-form.component';
import { MaterialModule } from '../shared/material.module';
import { TransactionManagementModule } from '../pages/transaction/transaction-management.module';
import { CreditPurchaseModalComponent } from 'src/app/pages/credit/credit-purchase-modal/credit-purchase-modal.component';
import { FineAdminInvoiceComponent } from '../pages/transaction-admin/fine-admin/fine-admin-invoice/fine-admin-invoice.component';
import { TransactionReceiptModalComponent } from './components/transaction-receipt-modal/transaction-receipt-modal.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InfractionDetailModalComponent } from './components/infraction-detail-modal/infraction-detail-modal.component';
import { AppTriggerChangeDetectionDirective } from './directives/app-trigger-change-detection.directive';
import { TwoFactorVerificationModalComponent } from './components/two-factor-verification-modal/two-factor-verification-modal.component';
import { ProfileSelectionModalComponent } from './components/profile-selection-modal/profile-selection-modal.component';
import { StepperRegisterComponent } from './components/stepper-register/stepper-register.component';
import { ResendActivateEmailComponent } from './components/resend-activate-email/resend-activate-email.component';
import { ErrorRegisterComponent } from './components/error-register/error-register.component';
import { ToolBarComponent } from './components/tool-bar/tool-bar.component';
import { MultiLangOriginalPipe } from './pipes/multi-lang-original.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { DialogCommentComponent } from './components/dialog-comment/dialog-comment.component';
import { TransactionAdminProfileModalComponent } from './components/transaction-admin-profile-modal/transaction-admin-profile-modal.component';
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    DocumentViewerComponent,
    PdfViewerComponent,
    DialogYesNoComponent,
    DialogOkComponent,
    TermsAndConditionsComponent,
    PaymentFormComponent,
    GenericPaymentFormComponent,
    RequirementReviewComponent,
    MainSearchResultsComponent,
    ComponentLoaderComponent,
    StreetPostalAddressFormComponent,
    CreditCardSelectorComponent,
    // MultiLanguagePipe,
    // MultiLanguageComplexPipe,
    SafePipe,
    EscapeHtmlPipe,
    ModuleLoadDirective,
    SubFormComponent,
    MainFormComponent,
    SolicitanteComponent,
    EmpresaComponent,
    AgenteComponent,
    CostFormComponent,
    CostItemComponent,
    CostItemAdminComponent,
    CostFormAdminComponent,
    LoaderComponent,
    PaymentPlanFormComponent,
    CreditPurchaseModalComponent,
    FineAdminInvoiceComponent,
    TransactionReceiptModalComponent,
    InfractionDetailModalComponent,
    AppTriggerChangeDetectionDirective,
    TwoFactorVerificationModalComponent,
    ProfileSelectionModalComponent,
    StepperRegisterComponent,
    ResendActivateEmailComponent,
    ErrorRegisterComponent,
    ToolBarComponent,
    MultiLangOriginalPipe,
    TruncatePipe,
    DialogCommentComponent,
    TransactionAdminProfileModalComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SharedModule,
    TranslateModule,
    DocumentViewerComponent,
    PdfViewerComponent,
    DialogYesNoComponent,
    DialogOkComponent,
    TermsAndConditionsComponent,
    FlexLayoutModule,
    PaymentFormComponent,
    PaymentPlanFormComponent,
    GenericPaymentFormComponent,
    RequirementReviewComponent,
    MainSearchResultsComponent,
    ComponentLoaderComponent,
    CardModule,
    StreetPostalAddressFormComponent,
    CreditCardSelectorComponent,
    NgxMaskModule,
    // MultiLanguagePipe,
    // MultiLanguageComplexPipe,
    SafePipe,
    EscapeHtmlPipe,
    ReactiveFormsModule,
    FormsModule,
    SolicitanteComponent,
    EmpresaComponent,
    AgenteComponent,
    CostFormComponent,
    CostItemComponent,
    CostItemAdminComponent,
    CostFormAdminComponent,
    LoaderComponent,
    CreditCardSelectorComponent,
    CreditPurchaseModalComponent,
    FineAdminInvoiceComponent,
    TransactionReceiptModalComponent,
    InfractionDetailModalComponent,
    AppTriggerChangeDetectionDirective,
    TwoFactorVerificationModalComponent,
    ProfileSelectionModalComponent,
    StepperRegisterComponent,
    ResendActivateEmailComponent,
    ErrorRegisterComponent,
    ToolBarComponent,
    MultiLangOriginalPipe,
    TruncatePipe,
    DialogCommentComponent,
    TransactionAdminProfileModalComponent
  ],
  imports: [
    MaterialModule,
    SharedModule,
    CommonModule,
    RouterModule,
    CardModule,
    FormsModule,
    CKEditorModule,
    ReactiveFormsModule,
    NgxExtendedPdfViewerModule,
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: rootLoaderFactory,
        deps: [HttpClient]
      },
    }),
  ],

  entryComponents: [
    DialogYesNoComponent,
    DialogOkComponent,
    TermsAndConditionsComponent,
    DocumentViewerComponent,
    PaymentFormComponent,
    PaymentPlanFormComponent,
    CreditPurchaseModalComponent,
    InfractionDetailModalComponent,
    TransactionReceiptModalComponent,
    TwoFactorVerificationModalComponent,
    ProfileSelectionModalComponent,
    ResendActivateEmailComponent,
    ErrorRegisterComponent,
    DialogCommentComponent,
    TransactionAdminProfileModalComponent
  ],

  providers: [
    CanDeactivateGuard,
    CurrencyPipe,
    TruncatePipe,
    PdfFindbarService,
  ],
})
export class CoreModule { }

export function rootLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/main/', '.json');
}
